<template>
  <AtomsGlobalDialog :is-open="dialog?.isOpen" :is-message-container="dialog?.isMessageContainer" @close="close" class="added-to-cart">
    <template v-if="cartItem">
      <div class="px-4 py-6 tablet:px-6 desktop:px-10">

        <!-- heading -->

        <strong class="block mb-8 pb-8 uppercase font-bold text-2xl border-b border-neutral-200 tablet:px-8">{{ $t('Zboží bylo přidáno do košíku') }}</strong>

        <!-- overcount -->

        <strong v-if="overcount" class="block mb-8 text-error-500">{{ $t('Bohužel jsme nemohli přidat do košíku požadované množství, protože není skladem. Aktuálně máte od tohoto produktu v košíku {0}', [$t('položku', cartItem.quantity)]) }}.</strong>

        <!-- cart item -->

        <MoleculesBlocksCartItem :hide-services="!includeLastService" :show-last-service-only="includeLastService" :hide-service-buttons="true" :presentation-cart-item="cartItem" :imageId="cartItem.imageId" :name="cartItem.name" :variant-name="cartItem.variantName" :code="cartItem.code" :piecePriceFormatted="cartItem.piecePriceFormatted" :totalPrice="cartItem.customCountPrice" :hide-remove-button="true" v-model="addedQuantity" :min="1" @update:modelValue="(...args) => updateCartItem(cartItem.cartItemId, ...args)" />

        <!-- buttons -->

        <div class="flex flex-wrap gap-4 justify-between" :class="{ 'mb-8 pb-8 border-b border-neutral-200': motivatorShown }">
          <MoleculesButtonsButton v-if="showEngravingButton" @click="cart.openServiceDialogForCartItem(cartItem, 'Popup po přidání do košíku')" :secondary-ghost="true" class="w-full tablet:ml-auto tablet:w-auto tablet:order-2 desktop:ml-0">+ {{ $t('Přikoupit gravírování') }}</MoleculesButtonsButton>
          <MoleculesButtonsButton :arrow-left="true" :ghost="true" class="order-1 w-full tablet:order-0 tablet:w-auto" @click="close">{{ $t('Zpět do obchodu') }}</MoleculesButtonsButton>
          <MoleculesButtonsButton :href="cache.getModuleUrl('modules/order/cart')" class="order-0 w-full tablet:order-1 tablet:w-auto desktop:ml-auto" @click="close">{{ $t('Přejít do košíku') }}</MoleculesButtonsButton>
        </div>

        <!-- motivator -->

        <div v-if="motivatorShown" class="inline-block">
          <MoleculesGlobalMotivator :required="cart.prices.value.freeShipping.required" :remaining="cart.prices.value.freeShipping.remaining" />
        </div>
      </div>
    </template>
  </AtomsGlobalDialog>
</template>
<script setup>

const appConfig = useAppConfig();
const cache = useCache();
const cart = useCart();

const dialog = computed(() => useDialog().get('addedToCart'));

const cartItem = computed(() => cart.presentation.value.find(cartPresentationItem => cartPresentationItem.cartItemId === dialog.value?.data?.cartItem.cartItemId));

const includeLastService = computed(() => dialog.value?.data?.includeLastService);
const showEngravingButton = computed(() => !includeLastService.value && cartItem.value.availableServices?.some(service => service.id === appConfig.wareServiceIds.engraving) && !cartItem.value.services);

const motivatorShown = computed(() => cart.prices.value.freeShipping.required && !cartItem.personalPickupOnly);

const addedQuantity = ref(cartItem.value?.relativeQuantity);
const overcount = ref(dialog.value?.data?.overcount);

watch(() => dialog.value?.data?.overcount, newVal => {
  overcount.value = newVal;
}, { flush: 'pre', immediate: false });

watch(() => cartItem.value?.relativeQuantity, (newVal, oldVal) => {
  addedQuantity.value = newVal;
}, { flush: 'pre', immediate: false });

const close = () => useDialog().close();

let isUpdating = false;

const updateCartItem = async (cartItemId, relativeQuantity) => {

  if (isUpdating) {
    return;
  }

  isUpdating = true;

  const updatingQuantity = relativeQuantity - cartItem.value.relativeQuantity;

  if (!(await useCart().update(cartItemId, updatingQuantity, false, relativeQuantity))) {
    overcount.value = true;
  }
  else {
    overcount.value = false;
  }

  addedQuantity.value = cartItem.value.relativeQuantity;

  isUpdating = false;
}

</script>
<style lang="postcss">
.added-to-cart {
  @apply w-[700px] desktop:w-[950px];

  .cart-item {

    @apply flex-wrap pb-8 mb-8 border-b border-neutral-200;

    &__image {
      @apply w-full mt-4 tablet:mt-0 tablet:w-[160px];

      img {
        @apply max-h-full mx-auto;
      }
    }

    &__description {
      @apply tablet:flex-1;
    }

    &__availability {
      @apply hidden;
    }

    &__quantity-with-price {
      @apply justify-between w-full tablet:w-auto tablet:-mr-4 tablet:flex-wrap tablet:justify-center;
    }

    &__quantity {
      @apply order-2;
    }

    &__price {
      @apply order-1 w-full min-w-[100px] tablet:text-center;

      &__piece {
        @apply text-left tablet:text-center;
      }
    }
  }
}
</style>